import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import {  PrivateLocatioDetails } from "../../domain";
import { MasterPlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetMasterPlanLocationDetailsByIdUseCase implements UseCase<string, PrivateLocatioDetails> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: string): Observable<PrivateLocatioDetails> {
    return this.masterPlanRepository.getMasterLocationDetailsById(params);
  }

}
